<template>
    <div>
        <div class="columns">
            <div class="column is-one-third my-content no-print" style="height: fit-content;">
                <h1 class="title is-5">ພິມ QR/Barcode</h1>
                <form @submit.prevent="generate()">
                    <b-field label="ເລືອກໝວດສິນຄ້າ">
                        <b-select v-model="generator.category" placeholder="ເລືອກໝວດສິນຄ້າ"
                                  expanded @input="getFilteredTags">
                            <option value="all">ເລືອກທັງໝົດ</option>
                            <option
                                    v-for="option in categories"
                                    :value="option.name"
                                    :key="option.code">
                                {{ option.name }}
                            </option>
                        </b-select>
                    </b-field>
                    <b-field label="ເລືອກສິນຄ້າ">
                        <b-taginput
                                v-model="selectedProducts"
                                ref="taginput"
                                :data="filteredProducts"
                                autocomplete
                                :allow-new="allowNew"
                                :open-on-focus="openOnFocus"
                                field="name"
                                icon="magnify"
                                placeholder="ປ້ອນຊື່ສິນຄ້າ ຫຼື ລະຫັດ"
                                :before-adding="onAddingProduct"
                                @typing="getFilteredTags"
                                :disabled="generator.printAll">
                            <template slot-scope="props">
                                <div class="columns">
                                    <div class="column">{{props.option.name}}</div>
                                    <div class="column has-text-right">{{props.option.code}}</div>
                                </div>
                            </template>
                            <template slot="empty">
                                ບໍ່ພົບສິນຄ້າ
                            </template>
                            <template slot="selected" slot-scope="props">
                                <b-tag
                                        v-for="(tag, index) in props.tags"
                                        :key="index"
                                        type="is-primary"
                                        rounded
                                        :tabstop="false"
                                        ellipsis
                                        closable
                                        @close="$refs.taginput.removeTag(index, $event)">
                                    {{tag.name}}
                                </b-tag>
                            </template>
                        </b-taginput>
                    </b-field>
                    <div style="padding: 5px 0;">
                        <b-switch v-model="generator.printAll">ພິມທັງໝົດ</b-switch>
                    </div>
                    <b-field label="ປະເພດການພິມ">
                        <b-radio-button v-model="generator.type"
                                        expanded
                                        native-value="QR"
                                        type="is-primary">
                            <b-icon icon="qrcode"></b-icon>
                            <span>QR Code</span>
                        </b-radio-button>

                        <b-radio-button v-model="generator.type"
                                        expanded
                                        native-value="BARCODE"
                                        type="is-primary">
                            <b-icon icon="barcode"></b-icon>
                            <span>Barcode</span>
                        </b-radio-button>
                    </b-field>
                    <b-field label="ຈໍານວນ/ສິນຄ້າ">
                        <b-input v-model="generator.qry"
                                 placeholder="ຈໍານວນ/ສິນຄ້າ"
                                 required
                                 @keypress.native="onInputNumber"
                                 validation-message="ຕ້ອງປ້ອນຈໍານວນ/ສິນຄ້າ"></b-input>
                    </b-field>
                    <hr>
                    <b-button type="is-danger"
                              class="button"
                              icon-left="wrench-outline"
                              native-type="submit" expanded>Generate
                    </b-button>
                    <b-button v-if="generatedProducts.length > 0"
                              class="mt-4"
                              icon-left="printer"
                              type="is-primary" expanded
                              @click="print">ພິມ
                    </b-button>
                </form>
            </div>
            <div v-if="generatedProducts.length > 0" class="column" style="padding-top: 0;">
                <div class="my-content">
                    <div v-if="generator.type === 'BARCODE'" class="my-row">
                        <div v-for="(item, index) in generatedProducts" :key="index" class="my-barcode-column">
                            <barcode class="barcode" :value='`${item.code}`' width="1" height="20" @load="onGenerated"/>
                        </div>
                    </div>
                    <div v-if="generator.type === 'QR'" class="my-row">
                        <div v-for="(item, index) in generatedProducts" :key="index"
                             :class='`my-qrcode-column ${index === 62 ? `page-break` : ``}`'>
                            <qrcode-vue :value='`${item.code}`' size="60" level="H"></qrcode-vue>
                            <span style="font-size: 10pt;">{{`${item.code}`}}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import VueBarcode from 'vue-barcode';
    import QrcodeVue from 'qrcode.vue'
    import {categoriesCollection, productsCollection} from "../firebase";

    export default {
        name: "PrintQrBarcode",
        components: {
            'barcode': VueBarcode,
            QrcodeVue
        },
        data() {
            return {
                generator: {
                    type: 'QR',
                    qry: 1,
                    category: null,
                    printAll: false
                },
                allowNew: true,
                openOnFocus: true,
                products: [],
                categories: [],
                filteredProducts: this.products,
                selectedProducts: [],
                generatedProducts: []
            }
        },
        firestore() {
            return {
                categories: categoriesCollection.where('deleted', '==', false).orderBy('created', 'desc'),
                products: productsCollection.where('deleted', '==', false).where('instock', '==', true).orderBy('created', 'desc')
            }
        },
        methods: {
            getFilteredTags(text) {
                if (text === 'all') {
                    this.filteredProducts = this.products;
                    return
                }
                this.filteredProducts = this.products.filter((item) => {
                    return item.name
                        .toString()
                        .toLowerCase()
                        .indexOf(text.toLowerCase()) >= 0 || item.code
                        .toString()
                        .toLowerCase()
                        .indexOf(text.toLowerCase()) >= 0 || item.category
                        .toString()
                        .toLowerCase()
                        .indexOf(text.toLowerCase()) >= 0
                })
            },
            onAddingProduct(tag) {
                return typeof (tag) === "object";
            },
            generate() {
                this.generatedProducts = [];
                let products = [];

                if (this.generator.category === null && this.selectedProducts.length === 0) {
                    this.$buefy.snackbar.open({
                        duration: 3000,
                        message: 'ຕ້ອງເລືອກສິນຄ້າທີ່ຈະການພິມກ່ອນ',
                        type: 'is-success',
                        position: 'is-bottom',
                        actionText: 'ຕົກລົງ',
                    });
                    return
                }

                if (this.generator.printAll) {
                    products = this.filteredProducts;
                } else {
                    products = this.selectedProducts;
                }

                if (products.length === 0) {
                    this.$buefy.snackbar.open({
                        duration: 3000,
                        message: 'ບໍ່ພົບສິນຄ້າທີ່ຈະການພິມ',
                        type: 'is-success',
                        position: 'is-bottom',
                        actionText: 'ຕົກລົງ',
                    });
                    return
                }

                products.map(item => {
                    for (let i = 0; i < parseInt(this.generator.qry); i++) {
                        this.generatedProducts.push({
                            code: item.code,
                            name: item.name,
                            price: item.price,
                        });
                    }
                });
            },
            onGenerated() {
                console.log('ok');
            },
            print() {
                window.print();
            }
        }
    }
</script>

<style scoped lang="scss">
    .my-row {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        width: 100%;
    }

    /* BARCODE */
    .my-barcode-column {
        display: flex;
        flex-direction: column;
        border-right: 1px dashed #aaa;
        border-bottom: 1px dashed #aaa;
        width: calc(100% / 7);
        align-items: center;
        padding-top: 2px;
    }

    .my-barcode-column:nth-child(7n+7) {
        border-right: none;
    }

    .my-barcode-column:last-child {
        border-right: none;
    }

    /* QR CODE*/
    .my-qrcode-column {
        display: flex;
        flex-direction: column;
        border-right: 1px dashed #aaa;
        border-bottom: 1px dashed #aaa;
        width: calc(100% / 7);
        align-items: center;
        padding: 8px 0;
    }

    .my-qrcode-column:nth-child(7n+7) {
        border-right: none;
    }

    .my-qrcode-column:last-child {
        border-right: none;
    }
</style>